const baseTheme = {
  id: 'base',
  backgroundColor: 'white',
  primaryColor: '#b60300', //base red #F82A2A'
  secondaryColor: '#0B6070', //aqua blue
  white: '#ffffff',
  black: '#0E0E0E',
  blackTrans: '#0e0e0feb',
  lightGrey: '#f4f4f4', // Used for backgrounds
  lightBlue: '#E2F2F5', // Used for backgrounds
  lightBlueText: 'rgba(255, 255, 255, 0.87)', // used as p styled text color on dark blue background
  lightGreyText: '#4A4A4A', // used as a secondary text color
  charcol: '#333',
  maxwidth: '960px',
  lightBlueLine: '#CBEBF0',
  shadow: '9px 8px 7px -2px rgba(227,224,227,0.84)'
};

export default baseTheme;
